import { render, staticRenderFns } from "./BuyerCampaignsList.vue?vue&type=template&id=be36167c&scoped=true"
import script from "./BuyerCampaignsList.vue?vue&type=script&lang=js"
export * from "./BuyerCampaignsList.vue?vue&type=script&lang=js"
import style0 from "./BuyerCampaignsList.vue?vue&type=style&index=0&id=be36167c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be36167c",
  null
  
)

export default component.exports